<script>

    import { createEventDispatcher } from 'svelte'

    import Spinner from './spinner.svelte'

    export let loading = false
    export let id = undefined

    const dispatch = createEventDispatcher()

    function handleSubmit(event) {
        event.preventDefault()
        dispatch('submit', event)
    }

</script>


<Spinner { loading } />

{#if !loading}
    <form {id} on:submit={handleSubmit}>
        <slot></slot>
    </form>
{/if}